import AccountLinkView from "../../views/auth/AccountLinkView";
import MaintenanceView from "../../views/MaintenanceView";
import PendingProfile from "../Loading/PendingProfile";
import PendingSystemAvailability from "../Loading/PendingSystemAvailability";
import ProfileUnavailableView from "../../views/profile/ProfileUnavailableView";
import React from "react";
import TermsOfUseView from "../../views/auth/TermsOfUseView";
import { connect } from "react-redux";
import { isObject } from "@pheaa/channels-component-library";
import { isRegistrationRequired, isTermsOfUseAgreementRequired } from "../../utils/profile";

const ProfileManager = props => {

	let returnElem = null;

	const {
		children,
		isFetchingProfile,
		isMaintenanceMode,
		isPendingMaintenanceStatus,
		isProfileNotFound,
		profileData
	} = props;

	if (isMaintenanceMode) {
		returnElem = <MaintenanceView isDynamicMaintenanceMode={true} />;
	} else if (isPendingMaintenanceStatus) {
		returnElem = <PendingSystemAvailability />;
	} else if (isFetchingProfile) {
		returnElem = <PendingProfile />;
	} else if (isProfileNotFound || isRegistrationRequired(profileData)) {
		returnElem = <AccountLinkView />;
	} else if (isTermsOfUseAgreementRequired(profileData)) {
		returnElem = <TermsOfUseView />;
	} else if (isObject(profileData)) {
		returnElem = children;
	} else {
		returnElem = <ProfileUnavailableView />;
	}

	return returnElem;
};

const mapStateToProps = state => ({
	isFetchingProfile: state.profile.isFetching,
	isMaintenanceMode: state.profile.isMaintenanceMode,
	isPendingMaintenanceStatus: state.profile.isPendingMaintenanceStatus,
	isProfileNotFound: state.profile.isProfileNotFound,
	profileData: state.profile.data
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileManager);